/**
 * Created by zhengyf on 2017/9/30.
 */

;(function() {
    angular
        .module('DSSXAPP')
        .component('aliIndexHeader', {
            template:'<div class="aliIndex-header aliIndex-header-wrap c-b"><div class="f-l logo"><a href="ali-index.html"><img src="/images/common/kuxiao.png" alt="logo"></a></div><div class="f-l left-item"><span>Sourcing Solutions</span> <i class="iconfont icon-moreunfold"></i></div><div class="f-l left-item"><span>Services & Membership</span> <i class="iconfont icon-moreunfold"></i></div><div class="f-l left-item"><span>Help & Community</span> <i class="iconfont icon-moreunfold"></i></div><div class="f-r p-t8"><a href="javascript:;" class="right-a1 f-c3">One Request, Multiple Quotes</a> <a href="javascript:;" class="split-line">|</a> <a href="javascript:;" class="right-a2 f-c3">Get the App</a></div></div>',
            bindings: {
                // catData: '<',
                // givenData: '<',
                // onUpdata: '&'
            },
            controllerAs: 'vm',
            controller: aliIndexHeader
        })

    function aliIndexHeader() {

    }

})();

